
import React from "react";
import {
	StyleSheet,
	Image,
} from "react-native";

import BlockView from "ae-base/Base/BlockView";
import StyledText from "ae-base/Base/StyledText";
import StyledButton from "ae-base/Base/StyledButton";
import ListItem from "ae-base/List/ListItem";
import ListContent from "ae-base/List/ListContent";

import ItemView from "./ItemView";

import { useResources } from "@aetonix/hooks";

import Style from "ae-style";

const styles = StyleSheet.create({
	imagePreview: {
		width: 64,
		height: 64,
	},
	viewButton: {
		marginRight: Style.layout.marginSmall,
	},
});

export default function FileItems(props) {
	const {
		localize,
	} = useResources();

	var files = props.files;
	var schema = props.schema;
	var screen = props.screen;

	var renderedFiles = files.map(function (file) {
		var format = file.format;
		var id = file.id;

		if(format === "image")
			return (
				<ImageItem key={id} file={file} />
			);
		if(format === "video")
			return (
				<VideoItem key={id} file={file} />
			);
		if(format === "document" || format === "pdf" || format === "application/pdf" || format === "audio")
			return (
				<DocumentItem key={id} file={file} />
			);

		return null;
	});

	var renderEmptyFiles = !renderedFiles.length ? <StyledText>{localize("managedforms.emptyFiles")}</StyledText> : null;

	return (
		<ItemView schema={schema} screen={screen} >
			{renderedFiles}
			{renderEmptyFiles}
		</ItemView>
	);
}

function ImageItem(props) {
	var file = props.file;
	var source = {
		uri: file.url,
	};

	return (
		<FileItem file={file}>
			<Image resizeMethod="resize" style={styles.imagePreview} resizeMode="stretch" source={source} />
		</FileItem>
	);
}

function VideoItem(props){
	var file = props.file;

	return (
		<FileItem file={file} />
	);
}

function DocumentItem(props) {
	var file = props.file;

	return (
		<FileItem file={file} />
	);
}

function FileItem(props) {
	const {
		localize,
		dispatch,
	} = useResources();

	var children = props.children;

	var file = props.file;
	var format = file.format;
	var url = file.url;

	var name = (url.split("-").slice(-1)[0]) || "";
	var extension = name.split(".").slice(-1) || "";

	var viewfile = localize("managedformsview.viewfile");

	if(name.length > 32)
		name = name.slice(32 - extension.length - 6, -(extension.length + 3)) + "[...]." + extension;

	var openExternal = dispatch("fileviewer:trigger:view", {
		file: file,
	});

	var icon = "files";
	if(format === "image")
		icon = "picture";
	if(format === "video")
		icon = "video";
	if(format === "document")
		icon = "file";

	return (
		<ListItem>
			<BlockView style={styles.viewButton}>
				<StyledButton title={viewfile} icon={icon} onPress={openExternal} />
			</BlockView>
			<ListContent>
				<StyledText>{name}</StyledText>
			</ListContent>
			{children}
		</ListItem>
	);
}
